const getQueryVariables = query => {
  const vars = query.split('&');
  const queryParams = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const variable = decodeURIComponent(pair[0]);
    let value = decodeURIComponent(pair[1]);
    for (let j = 2; j < pair.length; ++j) {
      value += '=' + decodeURIComponent(pair[j]);
    }
    queryParams[variable] = value;
  }
  return queryParams;
};
export default getQueryVariables;
